import React from 'react';
import {Text, View, StyleSheet, Image, Font } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    headerContainer: {
        marginTop: 36
       
    }, 
    text: {
        margin: 12,
        fontSize: 11,
        textAlign: 'justify',
        fontFamily: 'Times-Roman',
        textAlign: 'left'
      },
      textTitle: {
        margin: 12,
        fontSize: 16,
        fontFamily: 'Oswald',
        fontWeight: "bold",
        textAlign: 'center'
      },
    logo: {
        width: 74,
        height: 66,
        //marginLeft: 'auto',
        //marginRight: 'auto'
    }
  });
  Font.register({
    family: 'Oswald',
    src: 'https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf'
  });
   
  const dependency = (score) => {
    if(score < 20) {
      return "TOTAL";
    } else if (score >= 20 && score <= 35) {
      return "GRAVE";
    } else if (score >= 40 && score <= 55) {
      return "MODERADO";
    } else if (score >= 60 && score <= 99) {
      return "LEVE";
    } else if (score >= 100) {
      return "INDEPENDIENTE";
    }
    return "INDEPENDIENTE";
  }

  const getDiagnoses = (diagnoses) => {
    let diagnosesAll = " "; 
    diagnoses.map( (item, index) => {
        diagnosesAll = diagnosesAll + item.description + ", ";
     });

     return diagnosesAll;
  }

  const CertificadoFuncional = ({patient, barthel, diagnoses}) => (
    <View style={styles.headerContainer}>
        <Text style={styles.textTitle}> 
        CERTIFICACIÓN DE DEPENDENCIA FUNCIONAL
        </Text>

        <Text  style={styles.text}>
Que el paciente {patient.firstName + " "+ patient.secondName + " "+ patient.lastName + " "+ patient.secondLastName} de {(new Date()).getFullYear() - (new Date(patient.birthday)).getFullYear()}  años de edad, identificado con CEDULA DE CIUDADANIA N.{patient.id} tiene como diagnósticos: {getDiagnoses(diagnoses)}.

</Text>

        <Text  style={styles.text}>
Que al paciente en mención le fue aplicado el ÍNDICE DE BARTHEL dando como resultado de {barthel.score} puntos DEPENDENCIA {dependency(barthel.score)},
</Text>

        <Text  style={styles.text}>
Que dichos diagnósticos le generaron al paciente efectos, consecuencias y/o secuelas a nivel {barthel.observations}, que lo llevaron a necesitar de ayuda por un tercero para la realización de las siguientes actividades: ALIMENTACION, ACTIVIDADES EN BAÑO, VESTIRSE / DESVESTIRSE, ASEO PERSONAL, MANEJO DE INODORO O RETRETE, TRASLADO SILLA - CAMA, SUBIR O BAJAR ESCALONES, MICCION - CONTROL VESICAL, DEPOSICIONES - CONTROL ANAL, DEAMBULACION - TRASLADO - ACOMPAÑAMIENTO.
</Text>

        <Text  style={styles.text}>
De acuerdo a lo mencionado anteriormente, se certifica que el/la paciente presenta una dependencia funcional {dependency(barthel.score)}.
</Text>

        <Text  style={styles.text}>
Para constancia,
</Text>

       
    </View>
  );
  
  export default CertificadoFuncional